"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shrinkToFitInImgRelative = void 0;
var utils_1 = require("../../utils");
/**
 * @description Rectを1x1正方形内に収まるようにする
 */
var shrinkToFitInImgRelative = function (target) {
    return target.withMutations(function (from) {
        var topClamped = Math.max(from.top, 0);
        var leftClamped = Math.max(from.left, 0);
        var rightClamped = Math.min((0, utils_1.right)(from), 1);
        var bottomClamped = Math.min((0, utils_1.bottom)(from), 1);
        from
            .set('top', topClamped)
            .set('left', leftClamped)
            .set('width', rightClamped - leftClamped)
            .set('height', bottomClamped - topClamped);
    });
};
exports.shrinkToFitInImgRelative = shrinkToFitInImgRelative;
